module.exports = __webpack_public_path__ + "img/sub32.8073b032.jpg";